import "core-js/modules/es.set.difference.v2.js";
import "core-js/modules/es.set.intersection.v2.js";
import "core-js/modules/es.set.is-disjoint-from.v2.js";
import "core-js/modules/es.set.is-subset-of.v2.js";
import "core-js/modules/es.set.is-superset-of.v2.js";
import "core-js/modules/es.set.symmetric-difference.v2.js";
import "core-js/modules/es.set.union.v2.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.filter.js";
import "core-js/modules/esnext.iterator.for-each.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
export default {
  data() {
    return {
      heightdata: false,
      List: [],
      defaultdataList: [],
      formObj: {
        level: '',
        category: '',
        address: '',
        title: ''
      },
      listStyle: {},
      upFlag: false,
      loading: true,
      query: {}
    };
  },
  components: {},
  watch: {
    '$attrs.datalist': {
      handler(val) {
        this.List = [...val.data];
        this.defaultdataList = [...val.data];
        if (this.List.length > 0) this.loading = false;
      }
    },
    '$attrs.style': {
      handler(val) {
        this.listStyle = {
          ...val
        };
        delete this.listStyle.width;
      },
      deep: true
    }
  },
  mounted() {
    this.query = this.$route.query;
    // query.formUserId === '1083493444' 武汉非遗地图 更换所在区字段 做匹配 20251106
  },
  methods: {
    gosearch() {
      let filters = {};
      Object.keys(this.formObj).forEach(item => {
        filters[item] = this.formObj[item] === '' ? [] : this.formObj[item].toString().split(',');
      });
      // 武汉非遗地图 新增判断
      if (this.query.formUserId === '1083493444') {
        filters[47] = filters.address;
        delete filters.address;
      }
      // 关键处理：如果 47 的值是 [""]（空字符串数组），转为空数组 []
      if (filters[47] && filters[47].length === 1 && filters[47][0].trim() === '') {
        filters[47] = [];
      }
      console.log(`filters`, filters);
      let cacheData = JSON.parse(JSON.stringify(this.defaultdataList));
      console.log(`cacheData`, cacheData);
      let filterArray = this.multiFilter(cacheData, filters);
      let data = JSON.parse(JSON.stringify(filterArray));
      this.List = data.map(item => {
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe35/g, '\uff08');
        item.itemformdata.title = item.itemformdata.title.replace(/\ufe36/g, '\uff09');
        return item;
      });
    },
    // 静态数据筛选
    multiFilter(array, filters) {
      const filterKeys = Object.keys(filters);
      return array.filter(item => {
        let itemflag = filterKeys.every(key => {
          // 自定义判断
          if (key === 'title') {
            return !!~item.itemformdata[key].indexOf(filters[key]);
          }
          if (key === '47') {
            // 若筛选条件为空数组，直接跳过筛选
            if (!filters[key].length) return true;
            // 1. 处理数据：提取 item.itemformdata[47] 中所有 val（去重+去空格）
            const itemVals = item.itemformdata[key] ? Array.from(new Set(item.itemformdata[key].map(item => String(item.val || '').trim()))) : [];

            // 2. 处理筛选条件：filters[47] 转为去空格后的字符串数组
            const filterVals = Array.isArray(filters[key]) ? filters[key].map(v => String(v || '').trim()) : [String(filters[key] || '').trim()];

            // 3. 判断逻辑：筛选条件的所有值是否都在数据的 val 集合中（按需调整逻辑）
            // 需求：筛选条件选中的区域，数据必须包含至少一个 → 用 some
            // 若需数据包含所有筛选条件 → 改用 every
            return filterVals.some(filterVal => itemVals.includes(filterVal));
          }
          if (!filters[key].length) return true;
          return !!~filters[key].indexOf(item.itemformdata[key]);
        });
        return itemflag;
      });
    },
    listmarkerclick(item) {
      this.upFlag = !this.upFlag;
      this.$emit('listclick', item);
    },
    listUp() {
      this.upFlag = !this.upFlag;
      this.$emit('listup', this.upFlag);
    },
    listDown() {
      this.upFlag = false;
    },
    get47data(data) {
      let result = '';
      if (data) {
        result = data.map(item => {
          return item.val;
        }).join('、');
      }
      return result;
    }
  }
};